<template>
  <div class="tinymce-editor">
    <editor
      v-model="myValue"
      :placeholder="placeholderHtml"
      :init="init"
      :disabled="disabled"
    ></editor>
  </div>
</template>
<script>
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver";
import "tinymce/icons/default/icons.min.js";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/autoresize";
import "../../../public/tinymce/plugin";
// import "tinymce/plugins/indent2em";

export default {
  components: {
    Editor,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholderText: {
      type: String,
      default: "",
    },
    // 基本路径，默认为空根目录，如果你的项目发布后的地址为目录形式，
    // 即abc.com/tinymce，baseUrl需要配置成tinymce，不然发布后资源会找不到
    uploadUrl: {
      type: String,
      default: "",
    },
    imgShowUrl: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    plugins: {
      type: [String, Array],
      default:
        "link lists image code table colorpicker textcolor wordcount contextmenu fullscreen autoresize placeholder",
    },
    toolbar: {
      type: [String, Array],
      default: function () {
        return [
          "formatselect | fontsizeselect | bold italic underline strikethrough | forecolor backcolor | table lists | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | link image | removeformat",
        ];
        // return ["undo redo | formatselect | fontsizeselect | bold italic underline strikethrough | forecolor backcolor | table lists | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | link image | removeformat"]
      },
    },
  },

  data() {
    return {
      placeholderHtml: this.placeholderText,
      init: {
        language_url: `tinymce/langs/zh_CN.js`,

        language: "zh_CN",
        skin_url: `tinymce/skins/ui/oxide`,
        content_css: `tinymce/skins/content/default/content.css`,
        fontsize_formats: "12px 14px 16px 18px 20px 24px 28px 32px 36px 42px",
        // skin_url: `tinymce/skins/ui/oxide-dark`, // 暗色系
        // content_css: `tinymce/skins/content/dark/content.css`, // 暗色系
        height: 350,
        plugins: this.plugins,
        toolbar: this.toolbar,
        branding: false,
        menubar: false,
        // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
        // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        images_upload_handler: (blobInfo, success, failure) => {
          let formdata = new FormData();
          formdata.append("file", blobInfo.blob());
          this.axios({
            method: "POST",
            // 这里是你的上传地址
            url: this.uploadUrl,
            data: formdata,
          })
            .then((res) => {
              success(this.imgShowUrl + res.data.data.store_result);
            })
            .catch((res) => {
              failure("error");
            });
        },
      },
      myValue: this.value,
    };
  },
  mounted() {
    tinymce.init({});
    // this.initTinymcePlaceholder();
  },
  methods: {
    // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    // 需要什么事件可以自己增加
    onClick(e) {
      // this.$emit("onClick", e, tinymce);
    },
    // 可以添加一些自己的自定义事件，如清空内容
    clear() {
      this.myValue = "";
    },
    initTinymcePlaceholder() {
      tinymce.PluginManager.add("placeholder", function (editor) {
        editor.on("init", function () {
          let label = new Label();
          onBlur();
          tinymce.DOM.bind(label.el, "click", onFocus);
          editor.on("focus", onFocus);
          editor.on("blur", onBlur);
          editor.on("change", onBlur);
          editor.on("setContent", onBlur);
          editor.on("keydown", onKeydown);
          function onFocus() {
            if (!editor.settings.readonly === true) {
              label.hide();
            }
            editor.execCommand("mceFocus", false);
          }
          function onBlur() {
            if (editor.getContent() == "") {
              label.show();
            } else {
              label.hide();
            }
          }
          function onKeydown() {
            label.hide();
          }
        });

        let Label = function () {
          let placeholder_text =
            editor.getElement().getAttribute("placeholder") ||
            editor.settings.placeholder;
          let placeholder_attrs = editor.settings.placeholder_attrs || {
            style: {
              position: "absolute",
              top: "5px",
              left: 0,
              color: "#888",
              padding: "1%",
              width: "98%",
              overflow: "hidden",
              "white-space": "pre-wrap",
            },
          };
          let contentAreaContainer = editor.getContentAreaContainer();

          tinymce.DOM.setStyle(contentAreaContainer, "position", "relative");

          // Create label el
          this.el = tinymce.DOM.add(
            contentAreaContainer,
            editor.settings.placeholder_tag || "label",
            placeholder_attrs,
            placeholder_text
          );
        };

        Label.prototype.hide = function () {
          tinymce.DOM.setStyle(this.el, "display", "none");
        };

        Label.prototype.show = function () {
          tinymce.DOM.setStyle(this.el, "display", "");
        };
      });
    },
  },
  watch: {
    value(newValue) {
      this.myValue = newValue;
    },
    myValue(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>
